import { showToast } from 'vant'
import { getLoginPathForSessionExpiry } from '@/utils/loginRedirect'

export function handleTokenExpired() {
  localStorage.removeItem('token')

  showToast('登录已过期，请重新登录')

  window.location.href = getLoginPathForSessionExpiry()
} 